import React, { Component, PropTypes } from 'react';

import { Alert } from './';

// Import the CSS
import '../../scss/components/_global-msg.scss';

export default class GlobalMsg extends Component {

	render () {
		return (
			<div id="global-msg">
				<Alert canDismiss={ true } style={ this.props.msg.type } dismissTimer={5000} { ...this.props}>
					<div className="row container" key={ this.props.msg.id }>
						<span className="cell">{ this.props.msg.message }</span>
						<span className="cell justify-right icon-close close-global-msg" />
					</div>
				</Alert>
			</div>
		);
	}
}

GlobalMsg.propTypes = {
	msg: PropTypes.object,
	onClick: PropTypes.func,
};




// WEBPACK FOOTER //
// ./src/assets/js/components/GlobalMsg.js